export default {
   /* 打开/创建 databaseName 数据库，然后 打开/创建 tableName 表 */
   openIDB(databaseName, tableName, version = 1) {
      let DB = null;
      DB = window.indexedDB.open(databaseName, version)
      DB.onerror = (event) => { return false };

      DB.onupgradeneeded = (event) => { // 创建数据表
         let db = event.target.result;
         if (!db.objectStoreNames.contains(tableName)) {
            let table = db.createObjectStore(tableName, { keyPath: 'time' });
            table.createIndex('phone', 'phone', { unique: false });
         }
      }
      return DB;
   },

   /* 获取 tableName 表全部数据 */
   allIDB(databaseName, tableName) {
      return new Promise((resolve) => {
         let request = this.openIDB(databaseName, tableName)
         request.onsuccess = () => {
            let db = request.result;
            let res = db.transaction([tableName]).objectStore(tableName).getAll();
            res.onsuccess = function () {
               if (res.result) {
                  resolve(res.result)
               } else {
                  resolve([])
               }
            }
         }
      })
   },

   /* 查询 tableName 表单条数据 */
   getIDB(databaseName, tableName, key) {
      return new Promise((resolve) => {
         let request = this.openIDB(databaseName, tableName)
         request.onsuccess = () => {
            let db = request.result;
            let res = db.transaction([tableName], 'readwrite').objectStore(tableName).get(key)
            res.onsuccess = function () {
               if (res.result) {
                  resolve(res.result)
               } else {
                  resolve(null)
               }
            }
         }
      })
   },

   /* 修改 tableName 表单条数据 */
   putIDB(databaseName, tableName, obj) {
      let request = this.openIDB(databaseName, tableName)
      request.onsuccess = () => {
         let db = request.result
         let res = db.transaction([tableName], 'readwrite')
            .objectStore(tableName)
            .put(obj) // 修改对应的数据
         res.onsuccess = function () {
            if (res.result) {
               return true;
            }
         }
      }
   },

   /* 新增 tableName 表单条数据 */
   addIDB(databaseName, tableName, obj) {
      console.log('要新增的数据：', obj);
      let request = this.openIDB(databaseName, tableName)
      request.onsuccess = () => {
         let db = request.result
         let res = db.transaction([tableName], 'readwrite')
            .objectStore(tableName)
            .add(obj)
         res.onsuccess = () => {
            console.log('数据写入成功', obj)
         }
         res.onerror = (event) => {
            console.log('数据写入失败', obj, event)
         }
      }
   },

   /* 删除 tableName 表单条数据 */
   deleteIDB(databaseName, tableName, key) {
      return new Promise((resolve) => {
         let request = this.openIDB(databaseName, tableName)
         request.onsuccess = () => {
            let db = request.result
            let res = db.transaction([tableName], 'readwrite')
               .objectStore(tableName)
               .delete(key)
            res.onsuccess = () => {
               let obj = {
                  code: 1,
                  msg: '数据删除成功'
               }
               resolve(obj)
            }
            res.onerror = () => {
               console.log('数据删除失败', key)
            }
         }
      })
   },

   deleteDatabase(databaseName) {
      let indexDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB
      indexDB.deleteDatabase(databaseName)
   },
   countIDB(databaseName, tableName) {
      return new Promise((resolve) => {
         let request = this.openIDB(databaseName, tableName)
         request.onsuccess = () => {
            let db = request.result
            let res = db.transaction([tableName])
               .objectStore(tableName)
               .count()
            res.onsuccess = function () {
               if (res.result) {
                  resolve(res.result)
               } else {
                  resolve(0)
               }
            }
         }
      })
   },
}
